import ContactCard, {IContactCard} from "../../ui/contactcard/contactcard";
import "../styles/contactus.scss"
import {useState} from "react";
import Button from "../../core/button/button";

const ContactUs = () => {
    const [name, setName] = useState("");
    const [number, setNumber] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [description, setDescription] = useState("");

    const contactItems: IContactCard[] = [
        {
            img: require("../../assets/images/icons/ContactNumber.svg").default,
            title: "0214466",
            body: "Tijar@gmail.com"
        },
        {
            img: require("../../assets/images/icons/ContactAddress.svg").default,
            title: "آدرس",
            body: "تهران ، خیابان گاندی ، بیست و سوم شمالی پلاک ۲۱"
        },
        {
            img: require("../../assets/images/icons/ContactAddress.svg").default,
            title: "آدرس",
            body: "تهران ، خیابان گاندی ، بیست و سوم شمالی پلاک ۲۱"
        },
        {img: require("../../assets/images/icons/ContactNumber.svg").default, title: "0214466", body: "Tijar@gmail.com"}
    ]
    return (
        <div className="Contact-Us">
            <div className="container">
                <div className="row">
                    {
                        contactItems.map((item, index) => {
                            return (
                                <div key={index} className="col-lg-6 col-12 mb-4">
                                    <ContactCard img={item.img} title={item.title} body={item.body}/>
                                </div>
                            );
                        })
                    }
                    <div className="col-lg-6 col-12 mb-4">
                        <div className="Container-Box">
                            <div className="row">
                                <div className="col-lg-6 col-12 mb-2">
                                    <input type="text" placeholder="نام و نام خانوادگی" onChange={e => {
                                        setName(e.target.value)
                                    }} name="name" id="" className="Information-Input"/>
                                </div>
                                <div className="col-lg-6 col-12 mb-2">
                                    <input type="text" placeholder={"شماره تلفن"} onChange={e => {
                                        setNumber(e.target.value)
                                    }} name="number" id="" className="Information-Input"/>
                                </div>
                                <div className="col-lg-6 col-12 mb-2">
                                    <input type="text" placeholder={"پست الکترونیکی"} onChange={e => {
                                        setEmail(e.target.value)
                                    }} name="email" id="" className="Information-Input"/>
                                </div>
                                <div className="col-lg-6 col-12 mb-2">
                                    <input type="text" placeholder={"موضوع پیام"} onChange={e => {
                                        setMessage(e.target.value)
                                    }} name="message" id="" className="Information-Input"/>
                                </div>
                                <div className="col-lg-12 col-12 mb-2">
                                    <textarea rows={5} placeholder={"توضیحات"} onChange={e => {
                                        setDescription(e.target.value)
                                    }} name="description" id="" className="Information-Input"/>
                                </div>
                            </div>
                            <Button action={() =>{}} type={"primary"} responsive={true}>فرستادن</Button>
                        </div>
                    </div>
                    <div className="col-lg-6 col-12 mb-4">
                        <div className="Container-Box h-100">
                            <img src={require("../../assets/images/photos/Map.png")} alt="" className="img-fluid"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ContactUs;